<template>
    <a-drawer
        :title="id === 0 ? 'Añadir nuevo lote' : 'Editar lote #' + id"
        :width="420"
        :visible="visible"
        :wrap-style="{ height: '100%', overflow: 'auto', paddingBottom: '108px' }"
        class="flex-1"
        @close="$emit('close')"
    >
        <validation-observer v-slot="{ passes, invalid }">
            <form @submit="passes(save)">
                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.article"
                            ret-key="code"
                            :app="app"
                            :item="id"
                            name="article"
                            title="Articulo"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.name"
                            :app="app"
                            :item="id"
                            name="name"
                            title="Nombre"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.quantity"
                            :app="app"
                            :item="id"
                            name="quantity"
                            title="Cantidad"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.expiration_date"
                            :app="app"
                            :item="id"
                            name="expiration_date"
                            title="Fecha de caducidad"
                        />
                    </div>
                </div>

                <div
                    :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        padding: '10px 16px',
                        textAlign: 'right'
                    }"
                >
                    <a-button
                        :style="{ marginRight: '8px' }"
                        @click="$emit('close')"
                    >
                        Cancelar
                    </a-button>
                    <a-button
                        type="primary"
                        html-type="submit"
                        :loading="loading"
                        :disabled="invalid"
                    >
                        {{ id === 0 ? 'Añadir' : 'Modificar' }}
                    </a-button>
                </div>
            </form>
        </validation-observer>
    </a-drawer>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            view: 'lotList',
            app: 'lots',
            loading: false,
            fields: {
                article: null,
                name: '',
                expiration_date: null,
                quantity: 0
            }
        };
    },
    methods: {
        async save() {
            this.loading = true;

            const params = {
                article: this.fields.article ? this.fields.article.key : null,
                name: this.fields.name,
                expiration_date: this.fields.expiration_date,
                quantity: this.fields.quantity
            };

            let data;
            if (this.id > 0) {
                data = await this.$gestios.items('lots').edit({ id: this.id, params });
            } else {
                data = await this.$gestios.items('lots').add({ params, view: this.view });
            }

            if (data.ok) this.$emit('close');

            this.loading = false;
        }
    }
};
</script>

<style>
</style>
